import { render, staticRenderFns } from "./DynamicData.vue?vue&type=template&id=772d3e9e"
import script from "./DynamicData.vue?vue&type=script&lang=js"
export * from "./DynamicData.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports